import ProjectsApi from '@app/api/public/ProjectsApi';
import { useQuery } from 'react-query';

const useGetProperties = () => {
    return useQuery('getProperties', ProjectsApi.getProperies);
};

export default useGetProperties;
